export default "__VITE_ASSET__Bvn_eCqf__"